import React from 'react'
import Note from '../../Note'

const ConfirmableCheckboxView = ({ note, children }) => {
  return (
    <div>
      {children}
      <br />
      <Note>{note}</Note>
    </div>
  )
}

export default ConfirmableCheckboxView



// WEBPACK FOOTER //
// ./src/Components/ConfirmableCheckbox/component/ConfirmableCheckboxView.js